import {
  getStorageProvidersInfo,
  STORAGE_SERVICES,
  StorageServiceName,
} from '../../../../account/store/services/types';

export function getServiceByUrl(url: string): StorageServiceName | undefined {
  const domain = getSecondLevelDomain(url) as StorageServiceName;
  if (domain && STORAGE_SERVICES.includes(domain)) {
    return domain;
  }

  return undefined;
}

export function getServiceTitleByUrl(url: string): string | undefined {
  const service = getServiceByUrl(url);
  if (service) {
    return (
      getStorageProvidersInfo().find((p) => p.value === service)?.label ||
      undefined
    );
  }

  return undefined;
}

function getSecondLevelDomain(url: string): string {
  try {
    const urlObj = new URL(url);
    const parts = urlObj.hostname.split('.');
    return parts.length < 2 ? '' : parts.slice(-2).join('.');
  } catch {
    return '';
  }
}
